import {
  Box,
  createStyles,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { ArrowBackRounded } from "@material-ui/icons";
import { useHistory } from "react-router";
import DataService from "../../../Service";
import HomeHeaderMenu from "../../Home/HomeHeaderMenu";
import CustomTab from "../../../Components/CustomTab";
import TranchDetails from "./TranchDetails";
import SupportingDocs from "./SupportingDocs";
import SupplierProgrammeNotes from "./SupplierProgrammeNotes/SupplierProgrammeNotes";
import ClientProgrammeNotes from "./ClientProgrammeNotes/ClientProgrammeNotes";
import React, { useEffect, useState } from "react";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: "100%",
    },

    heading: {
      fontSize: "18px",
      color: "#077f83",
      fontWeight: "bold",
    },

    key: {
      fontSize: "14px",
      color: "#EF7000",
      fontWeight: "bold",
    },

    value: {
      fontSize: "14px",
      color: "#232323",
    },
  })
);

function InvoiceDetails() {
  const classes = useStyles();
  const history = useHistory();
  const [assignementName, setAssignementName] = useState("");
  const [orgName, setorgName] = useState("");
  const [totalAmt, settotalAmt] = useState("");
  const [paymentTerms, setpaymentTerms] = useState("");
  let urlElements = window.location.href.split("/");
  const InvoiceID = `${urlElements[5]}`;
  const getData = () => {
    const params = {
      invoice_id: InvoiceID,
    };
    DataService.getDirectData(`/invoices/tranche_details`, params)
      .then((response) => {
        let assignementName = response.assignment_name;
        let orgName = response.organisation_name;
        let totalAmt = response.total_amount;
        let paymentTerms = response.payment_terms;
        setAssignementName(assignementName);
        setorgName(orgName);
        settotalAmt(totalAmt);
        setpaymentTerms(paymentTerms);
      })

      .catch((err) => {});
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <div className={classes.root}>
      <HomeHeaderMenu title="Finance Admin" />
      <section style={{ marginTop: 28 }}>
        {/* details container */}
        <Box borderBottom="1px solid #70707033" paddingBottom="20px">
          <Grid container direction="row" alignItems="center" justify="center">
            <Grid item container xs={11}>
              <Grid item xs={2}>
                <Box
                  width="fit-content"
                  display="flex"
                  alignItems="center"
                  style={{ cursor: "pointer" }}
                  onClick={() => history.goBack()}
                >
                  <ArrowBackRounded
                    style={{ color: "#EF7000", marginRight: 24 }}
                  />

                  <Typography className={classes.heading}>
                    Invoice details
                  </Typography>
                </Box>
              </Grid>
              <Grid item container xs={10}>
                {/* first row */}
                <Grid item container xs={12}>
                  <Grid item container xs={5}>
                    <Grid item xs={5}>
                      <Typography className={classes.key}>
                        Assignment ID
                      </Typography>
                    </Grid>
                    <Grid item xs={5}>
                      <Typography className={classes.value}>
                        {assignementName}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item container xs={5}>
                    <Grid item xs={5}>
                      <Typography className={classes.key}>
                        Total amount
                      </Typography>
                    </Grid>
                    <Grid item xs={5}>
                      <Typography className={classes.value}>
                        {totalAmt}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                {/* second row */}
                <Grid item container xs={12} style={{ marginTop: 12 }}>
                  <Grid item container xs={5}>
                    <Grid item xs={5}>
                      <Typography className={classes.key}>
                        Organization name
                      </Typography>
                    </Grid>
                    <Grid item xs={5}>
                      <Typography className={classes.value}>
                        {orgName}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item container xs={5}>
                    <Grid item xs={5}>
                      <Typography className={classes.key}>
                        Payment terms
                      </Typography>
                    </Grid>
                    <Grid item xs={5}>
                      <Typography
                        className={classes.value}
                        style={{
                          width: "416px",
                          textAlign: "justify",
                        }}
                      >
                        {paymentTerms}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>

        {/* tabs section */}
        <Box width="100%" mt="26px">
          <CustomTab
            tabNames={[
              "Tranche details",
              "Client program notes",
              "Supplier program notes",
              "Supporting documents",
            ]}
            tabContent={[
              <TranchDetails key={0} />,
              <ClientProgrammeNotes key={1} />,
              <SupplierProgrammeNotes key={2} />,
              <SupportingDocs key={3} />,
            ]}
          />
        </Box>
      </section>
    </div>
  );
}

export default InvoiceDetails;
